import {modals, permissionGroups, sftpConfigs} from "../../../ducks";
import {connect} from "react-redux";
import React, {useState} from "react";
import {Formik} from "formik";
import ModalComponent from "../../ModalComponent";
import {Button, Form, FormControl, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import ValidationErrors from "../../forms/ValidationErrors";
import PropTypes from "prop-types";
import FontAwesome from "react-fontawesome";


const EditSftpModal = ({sftpConfig = {}, onClose, onSave, onUnexpectedError}) => {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [editPassword, setEditPassword] = useState(false);

  const initialValues = {id: sftpConfig.id, host: sftpConfig.host || '', port: sftpConfig.port, directory: sftpConfig.directory, username: sftpConfig.username, display_name: sftpConfig.display_name }

  return <Formik
    initialValues={initialValues}
    onSubmit={
      values => {
        setLoading(true);
        onSave(values)
          .then(onClose)
          .catch(response => {
            setLoading(false);
            if (response.sftp_config && response.sftp_config.errors) {
              setErrors(response.sftp_config.errors);
            } else {
              onClose();
              onUnexpectedError();
            }
          });
      }
    }>
    {
      ({
         values,
         handleChange,
         handleSubmit,
         setValues
       }) => <ModalComponent
        title={sftpConfig.id ? 'Edit SFTP Configuration' : 'Add SFTP Configuration'}
        buttons={[
          <Button type="submit" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </Button>
        ]}>
        <ValidationErrors errors={errors}/>

        <Row className='mb-3'>
          <label className="form-label col-form-label col-8 text-end">SFTP Host Name</label>
          <div className="controls col-16">
            <FormControl type="text" name="host" defaultValue={values.host} onChange={handleChange}/>
          </div>
        </Row>
        <Row className='mb-3'>
          <label className="form-label col-form-label col-8 text-end">Port (optional)</label>
          <div className="controls col-16">
            <FormControl type="number" name="port" defaultValue={values.port} onChange={handleChange}/>
          </div>
        </Row>
        <h4 style={{color: 'darkred'}}>Do not enter your Finalsite Enrollment username/password here!</h4>
        <Row className='mb-3'>
          <label className="form-label col-form-label col-8 text-end">SFTP Username</label>
          <div className="controls col-16">
            <FormControl type="text" name="username" defaultValue={values.username} onChange={handleChange} autoComplete='new-password' autoFill='off' />
          </div>
        </Row>
        <Row className='mb-3'>
          <label className="form-label col-form-label col-8 text-end">SFTP Password</label>
          <div className="controls col-16">
            {(!sftpConfig.password_set || editPassword) ? (
              <FormControl type="password" name="password" defaultValue={values.password} onChange={handleChange} autoComplete='new-password' autoFill='off' />
              ) : (
              <Button variant="secondary" onClick={() => setEditPassword(true)}>Change Password</Button>
            )}
          </div>
        </Row>
        <Row className='mb-3'>
          <label className="form-label col-form-label col-8 text-end">Directory (optional)</label>
          <div className="controls col-16">
            <FormControl type="text" name="directory" defaultValue={values.directory} onChange={handleChange}/>
          </div>
        </Row>
        <Row className='mb-3'>
          <label className="form-label col-form-label col-8 text-end">Display Name (optional) <OverlayTrigger
            overlay={<Tooltip>Changes how this SFTP configuration is listed on the Scheduled Exports page. The SFTP host name will be used by default.</Tooltip>}
          >
            <FontAwesome name='info-circle'/>
          </OverlayTrigger></label>
          <div className="controls col-16">
            <FormControl type="text" name="display_name" defaultValue={values.display_name} onChange={handleChange}/>
          </div>
        </Row>
      </ModalComponent>
    }
  </Formik>;
};

EditSftpModal.propTypes = {
  sftpConfig: PropTypes.shape({
    id: PropTypes.string,
    host: PropTypes.string,
  })
};

const mapDispatchToProps = (dispatch) => ({
  onSave: config => dispatch(sftpConfigs.actions.save(config)).then(() => dispatch(sftpConfigs.actions.markDirty())),
  onClose: () => dispatch(modals.actions.hide()),
  onUnexpectedError: () => dispatch(modals.actions.show('UnexpectedError'))
});

export default connect(null, mapDispatchToProps)(EditSftpModal);
